import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import { interval } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-output',
  templateUrl: './output.component.html',
  styleUrls: ['./output.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OutputComponent implements OnInit {
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  ErrorMsg: string;
  SuccessMsg: string;
  searchText: string;
  FromDate: any;
  ToDate: any;
  ShownHeader: boolean = true;
  ShownInvoice: boolean = true;
  ShownInvoiceItems: boolean = true;
  ShownInvoiceContainer: boolean = true;
  ShownBonds: boolean = true;
  ShownGSTINs: boolean = true;
  ShownLicenses: boolean = true;
  ShownCertificateBond: boolean = true;
  ShownHeaderExport:boolean=true;
  Type: string;
  InProgressBOE = [] as any;
  DataSourceHeaderExport=[] as any;
  DataSourceInvoiceExport=[] as any;
  DataSourceInvoiceItemsExport=[] as any;
  DataSourceContainerExport=[] as any;
  DataSourceCertOfBondExport=[] as any;
  DataSourceBondExport=[] as any;
  DataSourceGSTExport=[] as any;
  DataSourceLicenseExport=[] as any;
  DataSourceItmDiscrepancyExport=[] as any;

  HeaderExport=[] as any;
  InvoiceExport=[] as any;
  InvoiceItemExport=[] as any;
  InvoiceItemDisExport=[] as any;
  ContainerExport=[] as any;
  CertBondsExport=[] as any;
  BondExport=[] as any;
  GSTExport=[] as any;
  LicenseExport=[] as any;

  sOnboardingId: string;
  AuditType:string;

  displayedColumns: string[] = ['sno', 'beno', 'bedate', 'paymentMethod', 'igmno', 'pol', 'coo', 'coc', 'blorMawb', 'hblorHawb', 'shptType', 'noOfPackages', 'packageUnit', 'grossWeight', 'grossWeightUnit'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  displayedColumnsInv: string[] = ['sno', 'beno', 'bedate', 'invoiceNo', 'invoiceDate', 'supplier', 'invoiceAmount', 'invoiceCurrency', 'toi', 'freightAmount', 'freightCurrency', 'insurance', 'svbAss', 'svbDuty', 'hssRate', 'hssAmount', 'discountRate', 'discountAmount', 'edd', 'xbeDutyFgInt', 'isAffiliate', 'exchangeRate'];
  dataSourceInv: MatTableDataSource<any[]>;
  @ViewChild('TableInvPaginator', { static: true }) tableInvPaginator: MatPaginator;
  @ViewChild('TableInvSort', { static: true }) tableInvSort: MatSort;
  @ViewChild('TABLE1') table1: ElementRef;

  displayedColumnsContainer: string[] = ['sno', 'boeno', 'boedate', 'slNo', 'container', 'filledType'];
  dataSourceContainer: MatTableDataSource<any[]>;
  @ViewChild('TableContainerPaginator', { static: true }) tableContainerPaginator: MatPaginator;
  @ViewChild('TableContainerSort', { static: true }) tableContainerSort: MatSort;
  @ViewChild('TABLE2') table2: ElementRef;

  displayedColumnsBonds: string[] = ['sno', 'beno', 'bedate', 'bondNo', 'bondAmount', 'bgrate', 'bgamount', 'bondDebited', 'bgdebited'];
  dataSourceBonds: MatTableDataSource<any[]>;
  @ViewChild('TableBondsPaginator', { static: true }) tableBondsPaginator: MatPaginator;
  @ViewChild('TableBondsSort', { static: true }) tableBondsSort: MatSort;
  @ViewChild('TABLE3') table3: ElementRef;

  displayedColumnsGstin: string[] = ['sno', 'beno', 'bedate', 'documentNo', 'type', 'stateCode', 'state', 'igstassVal', 'igstamount', 'gstcessAmount'];
  dataSourceGstin: MatTableDataSource<any[]>;
  @ViewChild('TableGstinPaginator', { static: true }) tableGstinPaginator: MatPaginator;
  @ViewChild('TableGstinSort', { static: true }) tableGstinSort: MatSort;
  @ViewChild('TABLE4') table4: ElementRef;

  displayedColumnsCertBond: string[] = ['sno', 'beno', 'bedate', 'cetno', 'date1', 'type1'];
  dataSourceCertBond: MatTableDataSource<any[]>;
  @ViewChild('TableCertBondPaginator', { static: true }) tableCertBondPaginator: MatPaginator;
  @ViewChild('TableCertBondSort', { static: true }) tableCertBondSort: MatSort;
  @ViewChild('TABLE6') table6: ElementRef;

  displayedColumnsLicense: string[] = ['sno', 'beno', 'invNo', 'invoiceNo', 'itemNo', 'licenceNo','itemNoInvoice', 'licenceDate', 'regNo', 'regDate', 'debitValue', 'qty', 'debitDuty'];
  dataSourceLicense: MatTableDataSource<any[]>;
  @ViewChild('TableLicensePaginator', { static: true }) tableLicensePaginator: MatPaginator;
  @ViewChild('TableLicenseSort', { static: true }) tableLicenseSort: MatSort;
  @ViewChild('TABLE5') table5: ElementRef;



  displayedColumnsInvItem: string[] = ['sno', 'beno', 'bedate', 'invoiceNo', 'invoiceDate', 'ritc', 'partNo', 'description', 'longDescription', 'licenceUsed', 'quantity', 'unitPrice', 'cnotn', 'cntonSlNo', 'cusDtyRt', 'bcdAmount', 'antiDmNotn', 'antiDmNotnSlno', 'antiDmUnitPrice', 'antiDmAmount', 'antiDmCurrencyCode', 'antiDmQty', 'enotn', 'entonSlNo', 'bcd', 'cvd', 'bcdfg', 'cvdfg', 'unit', 'assVal', 'excDtyRt', 'cvdamount', 'spExcDtyRt', 'spExDt', 'hcvdrt', 'hcvd', 'eccrt', 'ecc', 'shecc', 'cecrt', 'cec', 'cshecrt', 'cshec', 'swsrt', 'sws', 'igstnotn', 'igstnothSlNo', 'igstrt', 'gstcnotn', 'gstcnotnSlNo', 'gstcrt', 'gstc', 'pgAssVal', 'pgDutyVal'];
  dataSourceInvItem: MatTableDataSource<any[]>;
  @ViewChild('TableInvItemPaginator', { static: true }) tableInvItemPaginator: MatPaginator;
  @ViewChild('TableInvItemSort', { static: true }) tableInvItemSort: MatSort;
  @ViewChild('TABLE7') table7: ElementRef;

  displayedColumnsInvItemDis: string[] = ['sno', 'bE_No', 'invoiceNo', 'invoiceDate', 'partNo', 'description', 'longDescription', 'unitPrice', 'unit', 'cnotn', 'cntonSlNo', 'cusDtyRt', 'antiDmNotn', 'antiDmNotnSlno', 'antiDmUnitPrice', 'enotn', 'entonSlNo', 'excDtyRt', 'hcvdRt', 'eccRt', 'sheccRt', 'cecRt', 'cshecRt', 'swsRt', 'igstNotn', 'igstNothSlNo', 'igstRt', 'gstcNotn', 'gstcNotnSlNo', 'gstcRt'];
  dataSourceInvItemDis: MatTableDataSource<any[]>;
  @ViewChild('TableInvItemDisPaginator', { static: true }) tableInvItemDisPaginator: MatPaginator;
  @ViewChild('TableInvItemDisSort', { static: true }) tableInvItemDisSort: MatSort;
  @ViewChild('TABLE8') table8: ElementRef;

  vRead: string;
  vWrite: string;

  constructor(private http: HttpClient, private SpinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
    }
this.AuditType="Post";
    this.vRead = localStorage.getItem('AuditOutputRead');
    this.vWrite = localStorage.getItem('AuditOutputWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';

    this.Type = "0";
    this.BindInProgressBOE();
    interval(10000).subscribe(x => {
      
      this.BindInProgressBOE();
      if (this.ShownHeader == false)
        this.HeaderBtnClick();
      else if (this.ShownInvoice == false)
        this.InvoiceBtnClick();
      else if (this.ShownInvoiceContainer == false)
        this.ContainerBtnClick();
      else if (this.ShownBonds == false)
        this.BondBtnClick();
      else if (this.ShownGSTINs == false)
        this.GstinBtnClick();
      else if (this.ShownLicenses == false)
        this.LicenseBtnClick();
      else if (this.ShownCertificateBond == false)
        this.CertificateBondBtnClick();
      else if (this.ShownInvoiceItems == false)
        this.InvoiceItemBtnClick();
    });
  }
  ngAfterViewInit(): void {   
    //this.dataSource.paginator = this.paginator;
  }
  BindInProgressBOE() {
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInProgressdData').toPromise().then(
      (data: any) => {
        this.InProgressBOE = data;

      });
  }
  HeaderBtnClick() {
    debugger;
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }

    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = false;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;

    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetHeaderData', { params: params }).toPromise().then(
      (data: any) => {
       
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
      var value = this.http.get(environment.apiUrl + 'Output/GetHeaderDataExport', { params: params }).toPromise().then(
        (data: any) => {
          debugger;
          //var table = document.getElementById("tblHeader");
  this.HeaderExport=data;
        });
  }
  InvoiceBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = false;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }

    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceData', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSourceInv = new MatTableDataSource(data);
        this.dataSourceInv.data = data;
        this.dataSourceInv.paginator = this.tableInvPaginator;
        this.dataSourceInv.sort = this.tableInvSort;

      });

      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceDataExport', { params: params }).toPromise().then(
        (data: any) => {
this.InvoiceExport=data;
        });
  }
  ContainerBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = false;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceContainerData', { params: params }).toPromise().then(
      (data: any) => {
        
        this.dataSourceContainer = new MatTableDataSource(data);
        this.dataSourceContainer.data = data;
        this.dataSourceContainer.paginator = this.tableContainerPaginator;
        this.dataSourceContainer.sort = this.tableContainerSort;

      });

      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceContainerDataExport', { params: params }).toPromise().then(
           (data: any) => {
            debugger;
this.ContainerExport=data;
           });
  }

  BondBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = false;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceBondsData', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSourceBonds = new MatTableDataSource(data);
        this.dataSourceBonds.data = data;
        this.dataSourceBonds.paginator = this.tableBondsPaginator;
        this.dataSourceBonds.sort = this.tableBondsSort;

      });
      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceBondsDataExport', { params: params }).toPromise().then(
     (data: any) => {
this.CertBondsExport=data;
      });
      //CertBondsExport
  }

  GstinBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = false;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceGSTsData', { params: params }).toPromise().then(
      (data: any) => {
        
        this.dataSourceGstin = new MatTableDataSource(data);
        this.dataSourceGstin.data = data;
        this.dataSourceGstin.paginator = this.tableGstinPaginator;
        this.dataSourceGstin.sort = this.tableGstinSort;

      });

      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceGSTsDataExport', { params: params }).toPromise().then(
    (data: any) => {
      debugger;
this.GSTExport=data;
      });
  }

  LicenseBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    debugger;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = false;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUploadActive';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceLicensesData', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.dataSourceLicense = new MatTableDataSource(data);
        this.dataSourceLicense.data = data;
        this.dataSourceLicense.paginator = this.tableLicensePaginator;
        this.dataSourceLicense.sort = this.tableLicenseSort;

      });

      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceLicensesDataExport', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
this.LicenseExport=data;
      });
  }

  CertificateBondBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = true;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = false;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceCertificateBondData', { params: params }).toPromise().then(
      (data1: any) => {
        debugger;
        this.dataSourceCertBond = new MatTableDataSource(data1);
        this.dataSourceCertBond.data = data1;
        this.dataSourceCertBond.paginator = this.tableCertBondPaginator;
        this.dataSourceCertBond.sort = this.tableCertBondSort;

      });

      var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceCertificateBondDataExport', { params: params }).toPromise().then(
           (data: any) => {
this.CertBondsExport=data;
           });
  }

  InvoiceItemBtnClick() {
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('','Please Select A Customer First!');
      return;
    }
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.ShownHeader = true;
    this.ShownInvoice = true;
    this.ShownInvoiceItems = false;
    this.ShownInvoiceContainer = true;
    this.ShownBonds = true;
    this.ShownGSTINs = true;
    this.ShownLicenses = true;
    this.ShownCertificateBond = true;
    (document.getElementById('btnHeader') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnInvoice') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLineItem') as HTMLInputElement).className = 'btnUploadActive';
    (document.getElementById('btnContainer') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnCertBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnBond') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnGSTs') as HTMLInputElement).className = 'btnUpload';
    (document.getElementById('btnLicenses') as HTMLInputElement).className = 'btnUpload';
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return false;
    }

    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return false;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return false;
    }

    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    params = params.append('iOnboardingId', this.sOnboardingId);
    params = params.append('sAuditType', this.AuditType);
    var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceItemData', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.InvoiceItemExport=data;
        this.dataSourceInvItem = new MatTableDataSource(data);
        this.dataSourceInvItem.data = data;
        this.dataSourceInvItem.paginator = this.tableInvItemPaginator;
        this.dataSourceInvItem.sort = this.tableInvItemSort;

      });
      

    var value = this.http.get(environment.apiUrl + 'Output/GetItemDiscrepancy', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        
        this.dataSourceInvItemDis = new MatTableDataSource(data);
        this.dataSourceInvItemDis.data = data;
        this.dataSourceInvItemDis.paginator = this.tableInvItemDisPaginator;
        this.dataSourceInvItemDis.sort = this.tableInvItemDisSort;

      });
  }

  applyFilterHeader(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  applyFilterInvoice(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceInv.filter = filterValue;
  }
  applyFilterInvItem(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceInvItem.filter = filterValue;
  }
  applyFilterInvItemDis(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceInvItemDis.filter = filterValue;
  }
  applyFilterContainer(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceContainer.filter = filterValue;
  }
  applyFilterBonds(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceBonds.filter = filterValue;
  }
  applyFilterGstin(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceGstin.filter = filterValue;
  }
  applyFilterLicense(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceLicense.filter = filterValue;
  }
  applyFilterCertBond(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSourceCertBond.filter = filterValue;
  }
  exportexcelHeader(): void {
    /* table id is passed over here */
//     var vFromDate = this.FromDate;
//     var vToDate = this.ToDate;
//     if (vFromDate == undefined) {
//       this.isShownError = false;
//       this.ErrorMsg = "Please Select Search From Date.";
//       return ;
//     }
//     if (vToDate == undefined) {
//       this.isShownError = false;
//       this.ErrorMsg = "Please Select Search To Date.";
//       return ;
//     }
//     if (this.Type == undefined || this.Type == "0") {
//       this.isShownError = false;
//       this.ErrorMsg = "Please Select Any One Type.";
//       return ;
//     }
//     let params = new HttpParams();
//     params = params.append('dValidfrom', vFromDate);
//     params = params.append('dValidTo', vToDate);
//     params = params.append('sType', this.Type);
//     var value = this.http.get(environment.apiUrl + 'Output/GetHeaderDataExport', { params: params }).toPromise().then(
//       (data: any) => {
//         debugger;
//         //var table = document.getElementById("tblHeader");
// this.HeaderExport=data;
        /* table id is passed over here */   
       let element = document.getElementById('tblHeader'); 
       const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Header');

       /* save to file */
       XLSX.writeFile(wb, "Header.xlsx");

    // const workSheet = XLSX.utils.json_to_sheet(data);
    // const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    // /* generate workbook and add the worksheet */
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, workSheet, 'Header');

    // /* save to file */
    // XLSX.writeFile(wb, "Header.xlsx");
  // })
  }
  exportexcelInvoice(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
     /* table id is passed over here */   
     let element = document.getElementById('tblInvoice'); 
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Invoice');

     /* save to file */
     XLSX.writeFile(wb, "Invoice.xlsx");
    //  })
  }
  exportexcelInvoiceItem(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceItemDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
    /* table id is passed over here */   
    let element = document.getElementById('tblInvItems'); 
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'InvoiceItem');

    /* save to file */
    XLSX.writeFile(wb, "InvoiceItem.xlsx");
      //})
  }
  exportexcelInvoiceItemDis(): void {
    var vFromDate = this.FromDate;
    var vToDate = this.ToDate;
    if (vFromDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search From Date.";
      return ;
    }
    if (vToDate == undefined) {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Search To Date.";
      return ;
    }
    if (this.Type == undefined || this.Type == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Select Any One Type.";
      return ;
    }
    let params = new HttpParams();
    params = params.append('dValidfrom', vFromDate);
    params = params.append('dValidTo', vToDate);
    params = params.append('sType', this.Type);
    var value = this.http.get(environment.apiUrl + 'Output/GetItemDiscrepancyExport', { params: params }).toPromise().then(
      (data: any) => {
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'InvoiceItemDiscrepancy');

    /* save to file */
    XLSX.writeFile(wb, "InvoiceItemDiscrepancy.xlsx");
      })
  }
  exportexcelContainer(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceContainerDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
        let element = document.getElementById('tblContainer'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Container');
    
        /* save to file */
        XLSX.writeFile(wb, "Container.xlsx");
     // })
  }
  exportexcelBond(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceBondsDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
    /* table id is passed over here */
    let element = document.getElementById('tblBonds'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Bonds');
    
        /* save to file */
        XLSX.writeFile(wb, "Bonds.xlsx");
      //})
  }
  exportexcelGstin(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceGSTsDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
        let element = document.getElementById('tblGST'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'GST');
    
        /* save to file */
        XLSX.writeFile(wb, "GST.xlsx");
      //})
  }
  exportexcelLicense(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceLicensesDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
    /* table id is passed over here */
    let element = document.getElementById('tblLicense'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'License');
    
        /* save to file */
        XLSX.writeFile(wb, "License.xlsx");
    //  })
  }
  exportexcelCertBonds(): void {
    // var vFromDate = this.FromDate;
    // var vToDate = this.ToDate;
    // if (vFromDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search From Date.";
    //   return ;
    // }
    // if (vToDate == undefined) {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Search To Date.";
    //   return ;
    // }
    // if (this.Type == undefined || this.Type == "0") {
    //   this.isShownError = false;
    //   this.ErrorMsg = "Please Select Any One Type.";
    //   return ;
    // }
    // let params = new HttpParams();
    // params = params.append('dValidfrom', vFromDate);
    // params = params.append('dValidTo', vToDate);
    // params = params.append('sType', this.Type);
    // var value = this.http.get(environment.apiUrl + 'Output/GetBoeInvoiceCertificateBondDataExport', { params: params }).toPromise().then(
    //   (data: any) => {
    /* table id is passed over here */
    let element = document.getElementById('tblCertBond'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'CertBonds');
    
        /* save to file */
        XLSX.writeFile(wb, "CertBonds.xlsx");
      //})
  }
}
